/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                             StoreMenu                         ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class StoreMenu {

    listeOnglet = [
        {
            liOnglet  : "Accueil",
            selection : false,
            largeur   : 110,
            hauteur   : 25,
            premier   : true,
            liAction  : "accueil",
            afficher  : true,
            defaut    : true
        },
        {
            liOnglet  : "Liste des tomes",
            selection : false,
            largeur   : 150,
            hauteur   : 25,
            premier   : true,
            liAction  : "listetome",
            afficher  : true,
            defaut    : true
        },
        {
            liOnglet  : "Cartes d'Aros",
            selection : false,
            largeur   : 130,
            hauteur   : 25,
            premier   : true,
            liAction  : "carte",
            afficher  : true,
            defaut    : true
        },
        {
            liOnglet  : "Couvertures",
            selection : false,
            largeur   : 130,
            hauteur   : 25,
            premier   : true,
            liAction  : "couverture",
            afficher  : true,
            defaut    : true
        },
        // {
        //     liOnglet  : "Genèse de la saga",
        //     selection : false,
        //     largeur   : 150,
        //     hauteur   : 25,
        //     premier   : true,
        //     liAction  : "genese",
        //     afficher  : true,
        //     defaut    : true
        // },
        // {
        //     liOnglet  : "Le Jeu de Rôles",
        //     selection : false,
        //     largeur   : 140,
        //     hauteur   : 25,
        //     premier   : true,
        //     liAction  : "jdr",
        //     afficher  : true,
        //     defaut    : true
        // },
        // {
        //     liOnglet  : "Les livraisons",
        //     selection : false,
        //     largeur   : 130,
        //     hauteur   : 25,
        //     premier   : true,
        //     liAction  : "livraison",
        //     afficher  : true,
        //     defaut    : true
        // },
        {
            liOnglet  : "Contact",
            selection : false,
            largeur   : 118,
            hauteur   : 25,
            premier   : true,
            liAction  : "contact",
            afficher  : true,
            defaut    : true
        }

    ];

     x        = 8;
     y        = 115;
     vertical = false;

    /* ----------------------------------------------- */
    /* Modification de l'affichage d'un onglet du menu */
    /* ----------------------------------------------- */

    modifierAffichage (liOnglet,valeur=true){
    //   console.log("StoreMenu - modifierAffichage - liOnglet = ",liOnglet);
      if (!this.listeOnglet.find(onglet => onglet.liOnglet === liOnglet)) return; // Sécurité
      this.listeOnglet.find(onglet => onglet.liOnglet === liOnglet).afficher = valeur;
    }

}



// WEBPACK FOOTER //
// ./src/donnees/StoreMenu.js